module.exports = __webpack_public_path__ + "static/media/leverage.eb7cf2cc.png";